module.exports = require("hard-source-webpack-plugin-fixed-hashbug");